import {
  Box,
  Button,
  Divider,
  List,
  ListItem,
  Typography,
  Tooltip,
  Drawer,
  Avatar,
  IconButton
} from "@mui/material";
import { useContext, useMemo, useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import PropTypes from "prop-types";
import { LOCAL_STORAGE_TOKENS } from "../../utils/constants";

import { PATH_PAGE } from "../../routes/paths";
import Logo from "../../assets/Budgeto Logo_ white.svg";
import BackIcon from "../../assets/svg/menu/BackIcon";
import { useData } from "../../contexts/DataContext";
import { useMsal } from "@azure/msal-react";
import { LogoutOutlined } from "@mui/icons-material";
import Scrollbar from "../../components/Scrollbar";
import TimesheetContext from "../../contexts/TimesheetContext";
import UserIcon from "../../assets/svg/navigation/user-icon.svg";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import NavigationContext from "../../contexts/NavigationContext";
import { accessibleFeatures } from "../../utils/rolesAccessMapping";

import EffortEstimationIcon from "../../assets/svg/navigation/effort-estimation.svg";
import PricingIcon from "../../assets/svg/navigation/pricing.svg";
import ContractIcon from "../../assets/svg/navigation/contracts.svg";
import PurchaseOrderIcon from "../../assets/svg/navigation/purchase-order.svg";
import MilestoneIcon from "../../assets/svg/navigation/milestone.svg";
import InsightsIcon from "../../assets/svg/navigation/insights.svg";
import ClientManagementIcon from "../../assets/svg/navigation/client-management.svg";
import TimesheetIcon from "../../assets/svg/navigation/timesheet.svg";
import ResourceMetricsIcon from "../../assets/svg/navigation/resource_management.svg";
import RateCardIcon from "../../assets/svg/navigation/rate-card.svg";
import ResourceAllocationIcon from "../../assets/svg/navigation/resource-allocation.svg";
import BudgetoReportsIcon from "../../assets/svg/navigation/budgeto-reports.svg";

import RateCardConfigIcon from "../../assets/svg/navigation/rate-card-config.svg";
import SkillPayrateIcon from "../../assets/svg/navigation/skill-payrate.svg";
import CustomerAccessIcon from "../../assets/svg/navigation/customer-access.svg";
import AssetManagementIcon from "../../assets/svg/navigation/employee-management.svg";
import EmployeeManagementIcon from "../../assets/svg/navigation/employee-management.svg";
import OverviewIcon from "../../assets/svg/navigation/overview.svg";
import ResourceInsightsIcon from "../../assets/svg/navigation/resource-insights.svg";

import InvoicesIcon from "../../assets/svg/navigation/invoices.svg";
import budgetManagement from "../../assets/svg/navigation/budget-management.svg";
import invoiceConfiguration from "../../assets/svg/navigation/invoice-configuration.svg";
import { useProfiles } from "../../contexts/ProfilesContext";
import { useSelectedTab } from "../../contexts/SelectedTabContext";
const Sidebar = ({ mobileOpen, onMobileClose }) => {
  const profiles = useProfiles();
  const { userData } = useData();
  const userRoles = userData?.user_roles || [];
  const { instance } = useMsal();
  const { pathname } = useLocation();
  const checkAccess = (allowedRoles = []) => {
    return (
      Array.isArray(allowedRoles) &&
      allowedRoles.some((role) => userRoles.includes(role))
    );
  };
  const hasManagerTabAcess = checkAccess(
    accessibleFeatures.timesheet.timesheetManagerTab
  );

  const { localKey_selectedClient, localKey_userData } = LOCAL_STORAGE_TOKENS;
  const navigate = useNavigate();

  const selectedClientName =
    JSON.parse(localStorage.getItem(localKey_selectedClient) || "{}")?.name ||
    "";

  const isProd = process.env.REACT_APP_PROFILE === "prod";
  const navigationContextValue = useContext(NavigationContext);
  const { selectedNavigationTab, setSelectedNavigationTab } = useSelectedTab();

  const navigationList = useMemo(() => {
    const getLabelByKey = (tabArray, key) => {
      const item = tabArray.find((item) => item.key === key);
      return item ? item.label : null;
    };

    // Use navigationContextValue.navigationJson instead of tabNames
    const mainTab = navigationContextValue?.navigationJson?.mainTab || {};
    const clientTab = navigationContextValue?.navigationJson?.clientTab || {};
    const budgetTab = navigationContextValue?.navigationJson?.budgetTab || {};
    const sectionHeaders =
      navigationContextValue?.navigationJson?.sectionHeaders || {};

    const MainNavigation = [
      {
        label: sectionHeaders.main,
        visibleInProd: true,
        children: [
          {
            title: getLabelByKey(mainTab?.main || [], "dashboard"),
            path: PATH_PAGE.dashboardPage.root,
            icon: EffortEstimationIcon,
            allowedRoles: accessibleFeatures.sidebar.dashboard,
            visibleInProd: true,
            navType: "main"
          },
          {
            title: getLabelByKey(mainTab?.main || [], "client_management"),
            path: PATH_PAGE.dashboard,
            icon: ClientManagementIcon,
            allowedRoles: accessibleFeatures.sidebar.clientManagement,
            visibleInProd: true,
            navType: "main"
          },
          {
            title: getLabelByKey(mainTab?.main || [], "budget_management"),
            path: PATH_PAGE.budget,
            icon: budgetManagement,
            allowedRoles: accessibleFeatures.sidebar.budgetManagement,
            visibleInProd: true,
            navType: "main"
          },
          {
            title: getLabelByKey(mainTab?.main || [], "rate_card"),
            path: PATH_PAGE.rateCard.root,
            icon: RateCardIcon,
            allowedRoles: accessibleFeatures.sidebar.rateCard,
            visibleInProd: true,
            navType: "main"
          }
        ]
      },

      {
        label: sectionHeaders.resourceManagement,
        visibleInProd: true,
        children: [
          // {
          //   title: getLabelByKey(
          //     mainTab?.resource_management || [],
          //     "resource_metrics"
          //   ),
          //   path: PATH_PAGE.resourcesManagement.root,
          //   icon: ResourceMetricsIcon,
          //   allowedRoles: accessibleFeatures.sidebar.resourceMetrics,
          //   visibleInProd: false,
          //   navType: "main"
          // },
          {
            title: getLabelByKey(
              mainTab?.resource_management || [],
              "resource_allocation"
            ),
            path: PATH_PAGE.resourcesManagement.utilization,
            icon: ResourceAllocationIcon,
            allowedRoles: accessibleFeatures.sidebar.resourceUtilization,
            visibleInProd: true,
            navType: "main"
          },
          {
            title: getLabelByKey(
              mainTab?.resource_management || [],
              "resource_insights"
            ),
            path: PATH_PAGE.resourcesManagement.insights,
            icon: ResourceInsightsIcon,
            allowedRoles: accessibleFeatures.sidebar.resourceInsights,
            visibleInProd: true,
            navType: "main"
          }
        ]
      },
      {
        label: sectionHeaders.timesheetManagement,
        visibleInProd: true,
        children: [
          {
            title: getLabelByKey(
              mainTab?.timesheet_management || [],
              "timesheets"
            ),
            path: PATH_PAGE.timesheetManagement.empTimesheetOverview,
            icon: TimesheetIcon,
            visibleInProd: true,
            navType: "main"
          },

          {
            title: getLabelByKey(
              mainTab?.timesheet_management || [],
              "manager_view"
            ),
            path: PATH_PAGE.timesheetManagement.managerView,
            icon: BudgetoReportsIcon,
            allowedRoles: accessibleFeatures.sidebar.managerView,
            visibleInProd: true,
            navType: "main"
          },
          {
            title: getLabelByKey(
              mainTab?.timesheet_management || [],
              "budgeto_reports"
            ),
            path: PATH_PAGE.exportTimesheetManagement.root,
            icon: BudgetoReportsIcon,
            allowedRoles: accessibleFeatures.sidebar.budgetoReports,
            visibleInProd: true,
            navType: "main"
          }
        ]
      },

      {
        label: sectionHeaders.admin,
        visibleInProd: true,
        children: [
          {
            title: getLabelByKey(mainTab?.settings || [], "asset_management"),
            path: PATH_PAGE.setting.asset,
            allowedRoles: accessibleFeatures.sidebar.assetManagement,
            visibleInProd: true,
            icon: AssetManagementIcon,
            navType: "main"
          },
          {
            title: getLabelByKey(
              mainTab?.settings || [],
              "employee_management"
            ),
            path: PATH_PAGE.setting.employee,
            allowedRoles: accessibleFeatures.sidebar.employeeManagement,
            visibleInProd: true,
            icon: EmployeeManagementIcon,
            navType: "main"
          },
          {
            title: getLabelByKey(mainTab?.settings || [], "customer_access"),
            path: PATH_PAGE.setting.customeraccess,
            icon: SkillPayrateIcon,
            allowedRoles: accessibleFeatures.sidebar.customerAccess,
            visibleInProd: true,
            navType: "main"
          },
          {
            title: getLabelByKey(
              mainTab?.settings || [],
              "skill_payrate_config"
            ),
            path: PATH_PAGE.setting.skillPayrateConfigList,
            icon: CustomerAccessIcon,
            allowedRoles: accessibleFeatures.sidebar.skillPayrateConfig,
            visibleInProd: true,
            navType: "main"
          },
          {
            title: getLabelByKey(mainTab?.settings || [], "rate_card_config"),
            path: PATH_PAGE.setting.root,
            icon: RateCardConfigIcon,
            allowedRoles: accessibleFeatures.sidebar.rateCardConfig,
            visibleInProd: true,
            navType: "main"
          },
          {
            title: getLabelByKey(
              mainTab?.settings || [],
              "invoice_configurations"
            ),
            path: PATH_PAGE.setting.invoiceSettings,
            icon: invoiceConfiguration,
            allowedRoles: accessibleFeatures.sidebar.invoicesConfig,
            visibleInProd: true,
            navType: "main"
          }
        ]
      }
    ];
    const clientNavItems = [
      {
        title: getLabelByKey(clientTab?.overview || [], "client_overview"),
        path: PATH_PAGE.client.detail,
        icon: OverviewIcon,
        allowedRoles: accessibleFeatures.sidebar.clientDetail,
        visibleInProd: true,
        navType: "client"
      },
      {
        label: sectionHeaders.estimation,
        visibleInProd: true,
        children: [
          {
            title: getLabelByKey(
              clientTab?.estimation || [],
              "effort_estimation"
            ),
            path: PATH_PAGE.estimation.root,
            icon: EffortEstimationIcon,
            allowedRoles: accessibleFeatures.sidebar.effortEstimation,
            visibleInProd: true,
            navType: "client"
          },
          {
            title: getLabelByKey(clientTab?.estimation || [], "pricing"),
            path: PATH_PAGE.estimation.pricing,
            icon: PricingIcon,
            allowedRoles: accessibleFeatures.sidebar.pricing,
            visibleInProd: true,
            navType: "client"
          }
        ]
      },
      {
        label: sectionHeaders.contractManagement,
        visibleInProd: true,
        children: [
          {
            title: getLabelByKey(
              clientTab?.contract_management || [],
              "sow_contracts"
            ),
            path: PATH_PAGE.contracts.root,
            icon: ContractIcon,
            allowedRoles: accessibleFeatures.sidebar.contractDetails,
            visibleInProd: true,
            navType: "client"
          },
          // {
          //   title: getLabelByKey(
          //     clientTab?.contract_management || [],
          //     "milestones"
          //   ),
          //   path: PATH_PAGE.contracts.milestones,
          //   icon: MilestoneIcon,
          //   allowedRoles: accessibleFeatures.sidebar.milestones,
          //   visibleInProd: true,
          //   navType: "client"
          // },
          {
            title: getLabelByKey(
              clientTab?.contract_management || [],
              "purchase_orders"
            ),
            path: PATH_PAGE.contracts.purchaseOrder,
            icon: PurchaseOrderIcon,
            allowedRoles: accessibleFeatures.sidebar.purchaseOrders,
            visibleInProd: true,
            navType: "client"
          }
        ]
      },
      {
        label: sectionHeaders.billing,
        visibleInProd: true,
        children: [
          {
            title: getLabelByKey(clientTab?.billing || [], "allocations"),
            path: PATH_PAGE.allocation.root,
            icon: ResourceAllocationIcon,
            allowedRoles: accessibleFeatures.sidebar.allocations,
            visibleInProd: true,
            navType: "client"
          },
          {
            title: getLabelByKey(clientTab?.billing || [], "invoices"),
            path: PATH_PAGE.invoicing.root,
            icon: InvoicesIcon,
            allowedRoles: accessibleFeatures.sidebar.invoices,
            visibleInProd: true,
            navType: "client"
          },
          {
            title: getLabelByKey(clientTab?.billing || [], "insights"),
            path: PATH_PAGE.insights.root,
            icon: InsightsIcon,
            allowedRoles: accessibleFeatures.sidebar.insights,
            visibleInProd: true,
            navType: "client"
          }
        ]
      }
    ];

    const budgetNavItems = [
      {
        title: getLabelByKey(budgetTab?.overview || [], "budget_overview"),
        path: PATH_PAGE.budget,
        icon: OverviewIcon,
        allowedRoles: accessibleFeatures.sidebar.budgetDetail,
        visibleInProd: true,
        navType: "budget"
      },
      {
        label: sectionHeaders.budgetEstimation,
        visibleInProd: true,
        children: [
          {
            title: getLabelByKey(
              budgetTab?.budget_estimation || [],
              "effort_estimation"
            ),
            path: PATH_PAGE.estimation.root,
            icon: EffortEstimationIcon,
            allowedRoles: accessibleFeatures.sidebar.effortEstimation,
            visibleInProd: true,
            navType: "budget"
          },
          {
            title: getLabelByKey(
              budgetTab?.budget_estimation || [],
              "requisition"
            ),
            path: PATH_PAGE.estimation.pricing,
            icon: PricingIcon,
            allowedRoles: accessibleFeatures.sidebar.pricing,
            visibleInProd: true,
            navType: "budget"
          }
        ]
      },
      {
        label: sectionHeaders.actualManagement,
        visibleInProd: true,
        children: [
          {
            title: getLabelByKey(
              budgetTab?.contract_management || [],
              "approval"
            ),
            path: PATH_PAGE.contracts.root,
            icon: ContractIcon,
            allowedRoles: accessibleFeatures.sidebar.contractDetails,
            visibleInProd: true,
            navType: "budget"
          },
          // {
          //   title: getLabelByKey(
          //     budgetTab?.contract_management || [],
          //     "schedule"
          //   ),
          //   path: PATH_PAGE.contracts.milestones,
          //   icon: MilestoneIcon,
          //   allowedRoles: accessibleFeatures.sidebar.milestones,
          //   visibleInProd: true,
          //   navType: "budget"
          // },
          {
            title: getLabelByKey(
              budgetTab?.contract_management || [],
              "budget_order"
            ),
            path: PATH_PAGE.contracts.purchaseOrder,
            icon: PurchaseOrderIcon,
            allowedRoles: accessibleFeatures.sidebar.purchaseOrders,
            visibleInProd: true,
            navType: "budget"
          }
        ]
      },
      {
        label: sectionHeaders.billing,
        visibleInProd: true,
        children: [
          {
            title: getLabelByKey(budgetTab?.billing || [], "placements"),
            path: PATH_PAGE.allocation.root,
            icon: ResourceAllocationIcon,
            allowedRoles: accessibleFeatures.sidebar.allocations,
            visibleInProd: true,
            navType: "budget"
          },
          {
            title: getLabelByKey(budgetTab?.billing || [], "actuals"),
            path: PATH_PAGE.invoicing.root,
            icon: InvoicesIcon,
            allowedRoles: accessibleFeatures.sidebar.invoices,
            visibleInProd: true,
            navType: "budget"
          },
          {
            title: getLabelByKey(budgetTab?.billing || [], "insights"),
            path: PATH_PAGE.insights.root,
            icon: InsightsIcon,
            allowedRoles: accessibleFeatures.sidebar.insights,
            visibleInProd: true,
            navType: "budget"
          }
        ]
      }
    ];

    let navItems;

    if (selectedNavigationTab === "client") {
      navItems = clientNavItems;
    } else if (selectedNavigationTab === "budget") {
      navItems = budgetNavItems;
    } else {
      navItems = MainNavigation;
    }

    return navItems
      .map((item) => {
        if (item.children) {
          const filteredChildren = item.children.filter(
            (child) => !isProd || child.visibleInProd
          );

          return filteredChildren.length > 0 || !isProd || item.visibleInProd
            ? { ...item, children: filteredChildren }
            : null;
        }

        return !isProd || item.visibleInProd ? item : null;
      })
      .filter(Boolean);
  }, [
    selectedNavigationTab,
    selectedClientName,
    isProd,
    navigationContextValue.navigationJson
  ]);

  const handleLogoClick = () => {
    setSelectedNavigationTab("main");
    localStorage.setItem("selectedTab", "main");
    if (selectedNavigationTab === "client") {
      navigate(PATH_PAGE.dashboard);
    } else {
      navigate(PATH_PAGE.budget);
    }

    localStorage.removeItem(localKey_selectedClient);
  };
  const handleLogout = (instance) => {
    localStorage.removeItem(localKey_selectedClient);
    localStorage.removeItem(localKey_userData);
    const logoutRequest = {
      account: instance.getAccountByHomeId(userData?.user_info?.email),
      postLogoutRedirectUri: `${process.env.REACT_APP_SERVER_URL}login`
    };
    instance.logoutRedirect(logoutRequest);
    navigate(PATH_PAGE.login);
  };
  const { pendingApprovalCount } = useContext(TimesheetContext);

  const containerStyle = {
    display: "flex",
    alignItems: "center",
    gap: "8px"
  };

  const badgeStyle = {
    backgroundColor: "#8056F7",
    color: "white",
    fontSize: "10px",
    fontWeight: "400",
    borderRadius: "12px",
    padding: "2px 4px",
    minWidth: "17px",
    height: "17px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    boxShadow: "0 0 4px rgba(0, 0, 0, 0.2)",
    lineHeight: "1",
    cursor: "pointer"
  };

  const isPathActive = (itemPath) => {
    if (pathname.includes("/estimation")) {
      if (itemPath === PATH_PAGE.estimation.root) {
        return (
          pathname === PATH_PAGE.estimation.root ||
          pathname === PATH_PAGE.estimation.detail
        );
      }
      if (itemPath === PATH_PAGE.estimation.pricing) {
        return pathname.includes("/pricing");
      }
    }

    if (pathname.includes("/contracts")) {
      if (itemPath === PATH_PAGE.contracts.root) {
        return (
          pathname === PATH_PAGE.contracts.root ||
          pathname === PATH_PAGE.contracts.detail
        );
      }
      if (itemPath === PATH_PAGE.contracts.milestones) {
        return pathname.includes("/milestone");
      }
      if (itemPath === PATH_PAGE.contracts.purchaseOrder) {
        return pathname.includes("/purchase-order");
      }
    }

    if (pathname.includes("/resources")) {
      if (itemPath === PATH_PAGE.resourcesManagement.root) {
        return (
          pathname === PATH_PAGE.resourcesManagement.root ||
          pathname === PATH_PAGE.resourcesManagement.detail
        );
      }
      if (itemPath === PATH_PAGE.resourcesManagement.utilization) {
        return pathname.includes("/utilization");
      }
    }

    if (pathname.includes("/timesheet")) {
      if (itemPath === PATH_PAGE.timesheetManagement.empTimesheetOverview) {
        return pathname.includes("/empTimesheet");
      }
    }

    if (pathname.includes("/setting")) {
      if (itemPath === PATH_PAGE.setting.root) {
        return pathname === PATH_PAGE.setting.root;
      }
      if (itemPath === PATH_PAGE.setting.skillPayrateConfigList) {
        return pathname.includes("/skill-payrate-config");
      }
      if (itemPath === PATH_PAGE.setting.customeraccess) {
        return pathname.includes("/customer-access");
      }
      if (itemPath === PATH_PAGE.setting.employee) {
        return pathname.includes("/employee");
      }
    }
    if (pathname.includes("/budget")) {
      return itemPath === PATH_PAGE.budget;
    }

    return pathname === itemPath;
  };

  const formatRoleName = (role) => {
    const isProd = process.env.REACT_APP_PROFILE === "prod";
    if (!role.includes("c2c")) return null;
    if (isProd && role.includes("_demo")) return null;
    if (!isProd && !role.includes("_demo")) return null;
    return role
      .replace(/c2c_/, "")
      .replace(/_demo$/, "")
      .split("_")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ");
  };

  const handleNavigationClick = (path, item, state = {}) => {
    if (item && item.navType) {
      setSelectedNavigationTab(item.navType);
      localStorage.setItem("selectedTab", item.navType);
    }
    navigate(path, { state });
  };

  const [expandedSections, setExpandedSections] = useState({});

  useEffect(() => {
    // Initialize all sections as expanded
    const initialExpandedState = {};
    navigationList.forEach((item) => {
      if (item.label) {
        initialExpandedState[item.label] = true;
      }
    });
    setExpandedSections(initialExpandedState);
  }, [navigationList]);

  const toggleSection = (label) => {
    setExpandedSections((prev) => ({
      ...prev,
      [label]: !prev[label]
    }));
  };

  const drawerContent = (
    <Box
      sx={{
        height: "100%",
        display: "flex",
        flexDirection: "column"
      }}
    >
      <Box
        sx={{
          backgroundColor: "#1C1D24",
          padding: "20px",
          borderBottom: "1px solid #35383E"
        }}
      >
        <Box
          onClick={handleLogoClick}
          sx={{
            width: "139px",
            height: "24px",
            cursor: "pointer"
          }}
        >
          <img alt="MatchPoint" src={Logo} />
        </Box>

        {selectedClientName && (
          <Button
            variant="outlined"
            onClick={handleLogoClick}
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "left",
              gap: "8px",
              borderColor: "#57B6D9",
              color: "#57B6D9",
              textTransform: "none",
              borderRadius: "40px",
              backgroundColor: "#22232D",
              fontSize: "13px",
              fontWeight: 500,
              marginTop: "10px",
              width: "140px"
            }}
          >
            <BackIcon /> Main Menu
          </Button>
        )}
      </Box>

      <Box
        sx={{
          flex: 1,
          overflow: "hidden",
          backgroundColor: "#1C1D24"
        }}
      >
        <Scrollbar
          sx={{
            height: "100%",

            "& .simplebar-scrollbar": {
              "&:before": {
                display: "none"
              }
            },

            "& .simplebar-track": {
              display: "none"
            },

            "& .simplebar-content-wrapper": {
              overflow: "auto !important",

              scrollbarWidth: "none",
              "&::-webkit-scrollbar": {
                display: "none"
              },
              "-ms-overflow-style": "none"
            }
          }}
        >
          <Box
            display="flex"
            justifyContent="center"
            alignItems="center"
            padding="10px"
          >
            <Box
              sx={{
                padding: "10px",
                borderRadius: 2,
                flexGrow: 1,
                border: "1px solid #35383E",
                backgroundColor: "#1b1b1b",
                width: "220px",
                display: "inline-block"
              }}
            >
              {selectedClientName && (
                <>
                  <Typography
                    variant="body1"
                    sx={{
                      fontWeight: 600,
                      fontSize: "16px",
                      color: "#ffffff",
                      marginBottom: 1
                    }}
                  >
                    {selectedClientName}
                  </Typography>
                  <Divider sx={{ backgroundColor: "#35383E", height: "1px" }} />
                </>
              )}

              <List>
                {navigationList.map((item, index) => (
                  <Box key={index}>
                    {item.label && (
                      <Box
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "space-between",
                          marginTop: 2,
                          marginRight: 1
                        }}
                      >
                        <Typography
                          variant="body2"
                          sx={{
                            color: "#979797",

                            fontWeight: 500,
                            fontSize: "12px"
                          }}
                        >
                          {item.label}
                        </Typography>
                        <IconButton
                          size="small"
                          onClick={() => toggleSection(item.label)}
                          sx={{
                            padding: "2px",
                            color: "#979797",
                            "&:hover": {
                              color: "#01CCFF"
                            }
                          }}
                        >
                          {expandedSections[item.label] ? (
                            <ExpandLessIcon fontSize="small" />
                          ) : (
                            <ExpandMoreIcon fontSize="small" />
                          )}
                        </IconButton>
                      </Box>
                    )}
                    {item.children &&
                      expandedSections[item.label] &&
                      item.children.map((child, childIndex) => {
                        const isAccessible =
                          child.title === "Timesheets" ||
                          checkAccess(child.allowedRoles);
                        const showBadge =
                          child.title === "Manager View" &&
                          pendingApprovalCount > 0;

                        return (
                          <Tooltip
                            key={childIndex}
                            title={
                              isAccessible
                                ? ""
                                : "You don't have access to this module"
                            }
                            placement="right"
                          >
                            <ListItem
                              sx={{
                                paddingY: 0.5,
                                color: isAccessible ? "#b3b3b3" : "#7E8799",
                                cursor: "pointer",
                                display: "flex",
                                alignItems: "center",
                                gap: "5px",
                                opacity: isAccessible ? 1 : 0.5,
                                backgroundColor: isPathActive(child.path)
                                  ? "#01CCFF"
                                  : "transparent",
                                "& img": {
                                  filter: isPathActive(child.path)
                                    ? "brightness(0)"
                                    : "none"
                                },
                                "& Typography": {
                                  color: isPathActive(child.path)
                                    ? "black !important"
                                    : "inherit"
                                },
                                "&:hover": {
                                  backgroundColor: isPathActive(child.path)
                                    ? "#01CCFF"
                                    : "rgba(1, 204, 255, 0.1)",
                                  borderRadius: "4px",
                                  "& img": {
                                    filter: isPathActive(child.path)
                                      ? "brightness(0)"
                                      : "none"
                                  },
                                  "& Typography": {
                                    color: isPathActive(child.path)
                                      ? "black !important"
                                      : "#01CCFF"
                                  }
                                },
                                borderRadius: "4px",
                                transition: "all 0.2s ease-in-out"
                              }}
                              onClick={() => {
                                if (isAccessible) {
                                  if (child.title === "Timesheets") {
                                    const tabToDisplay =
                                      profiles.isGuestUser ||
                                      profiles.isTimesheetAdmin ||
                                      hasManagerTabAcess
                                        ? "manager_view"
                                        : "ongoing_projects";

                                    handleNavigationClick(child.path, child, {
                                      tabToDisplay
                                    });
                                  } else {
                                    handleNavigationClick(child.path, child);
                                  }
                                }
                              }}
                            >
                              <img alt="nav-icon" src={child.icon} />
                              <Box style={containerStyle}>
                                <Typography
                                  sx={{
                                    fontWeight: 500,
                                    fontSize: "13px",
                                    color: isPathActive(child.path)
                                      ? "black"
                                      : "#7E8799",
                                    whiteSpace: "nowrap",
                                    overflow: "hidden"
                                  }}
                                >
                                  {child.title}
                                </Typography>
                                {showBadge && (
                                  <Tooltip
                                    title="Pending timesheets for approval"
                                    placement="right"
                                    arrow
                                  >
                                    <Box component="span" style={badgeStyle}>
                                      {pendingApprovalCount}
                                    </Box>
                                  </Tooltip>
                                )}
                              </Box>
                            </ListItem>
                          </Tooltip>
                        );
                      })}
                    {!item.children && (
                      <Tooltip
                        arrow
                        title={
                          item.title === "Timesheets" ||
                          checkAccess(item.allowedRoles)
                            ? ""
                            : "You don't have access to this module"
                        }
                        placement="right"
                      >
                        <ListItem
                          sx={{
                            gap: "5px",
                            paddingY: 0.5,
                            color:
                              item.title === "Timesheets" ||
                              checkAccess(item.allowedRoles)
                                ? "#b3b3b3"
                                : "#7E8799",
                            cursor: "pointer",
                            opacity:
                              item.title === "Timesheets" ||
                              checkAccess(item.allowedRoles)
                                ? 1
                                : 0.5,
                            backgroundColor: isPathActive(item.path)
                              ? "#01CCFF"
                              : "transparent",
                            "& img": {
                              filter: isPathActive(item.path)
                                ? "brightness(0)"
                                : "none"
                            },
                            "& Typography": {
                              color: isPathActive(item.path)
                                ? "black !important"
                                : "inherit"
                            },
                            "&:hover": {
                              backgroundColor: isPathActive(item.path)
                                ? "#01CCFF"
                                : "rgba(1, 204, 255, 0.1)",
                              borderRadius: "4px",
                              "& img": {
                                filter: isPathActive(item.path)
                                  ? "brightness(0)"
                                  : "none"
                              },
                              "& Typography": {
                                color: isPathActive(item.path)
                                  ? "black !important"
                                  : "#01CCFF"
                              }
                            },
                            borderRadius: "4px",
                            transition: "all 0.2s ease-in-out"
                          }}
                          onClick={() => {
                            if (
                              item.title === "Timesheets" ||
                              checkAccess(item.allowedRoles)
                            ) {
                              if (item.title === "Timesheets") {
                                handleNavigationClick(item.path, item, {
                                  number: 1,
                                  tabToDisplay:
                                    profiles.isGuestUser ||
                                    profiles.isTimesheetAdmin ||
                                    hasManagerTabAcess
                                      ? "manager_view"
                                      : "ongoing_projects"
                                });
                              } else {
                                handleNavigationClick(item.path, item);
                              }
                            }
                          }}
                        >
                          <img alt="nav-icon" src={item.icon} />
                          <Box style={containerStyle}>
                            <Typography
                              sx={{
                                fontWeight: 500,
                                fontSize: "13px",
                                color: isPathActive(item.path)
                                  ? "black"
                                  : "#7E8799"
                              }}
                            >
                              {item.title}
                            </Typography>
                            {item.title === "Manager View" &&
                              pendingApprovalCount > 0 && (
                                <Tooltip
                                  title="Pending timesheets for approval"
                                  placement="right"
                                  arrow
                                >
                                  <Box component="span" style={badgeStyle}>
                                    {pendingApprovalCount}
                                  </Box>
                                </Tooltip>
                              )}
                          </Box>
                        </ListItem>
                      </Tooltip>
                    )}
                  </Box>
                ))}
              </List>
            </Box>
          </Box>
        </Scrollbar>
      </Box>

      {/* Fixed Footer */}
      <Box
        sx={{
          padding: "16px",
          borderTop: "1px solid #35383E",
          backgroundColor: "#1C1D24"
        }}
      >
        {/* User Info Section */}
        <Tooltip
          title={
            <Box sx={{ p: 1 }}>
              <Box sx={{ mb: 1.5 }}>
                <Typography
                  sx={{
                    fontSize: "12px",
                    color: "#7E8799",
                    mb: 0.5
                  }}
                >
                  Email
                </Typography>
                <Typography
                  sx={{
                    fontSize: "13px",
                    color: "#ffffff"
                  }}
                >
                  {userData?.user_info?.email}
                </Typography>
              </Box>
              <Box>
                {userData?.user_roles?.map(formatRoleName).filter(Boolean)
                  .length > 0 && (
                  <>
                    <Typography
                      sx={{
                        fontSize: "12px",
                        color: "#7E8799",
                        mb: 0.5
                      }}
                    >
                      Roles
                    </Typography>
                    {userData?.user_roles
                      ?.map(formatRoleName)
                      .filter(Boolean)
                      .map((role, index) => (
                        <Typography
                          key={index}
                          sx={{
                            fontSize: "13px",
                            color: "#ffffff",
                            display: "flex",
                            alignItems: "center",
                            gap: "6px",
                            mb: 0.5
                          }}
                        >
                          <Box
                            sx={{
                              width: "4px",
                              height: "4px",
                              borderRadius: "50%",
                              backgroundColor: "#01CCFF"
                            }}
                          />
                          {role}
                        </Typography>
                      ))}
                  </>
                )}
              </Box>
            </Box>
          }
          placement="top-end"
          arrow
          sx={{
            "& .MuiTooltip-tooltip": {
              backgroundColor: "#1C1D24",
              border: "1px solid #35383E",
              borderRadius: "8px",
              maxWidth: "none"
            },
            "& .MuiTooltip-arrow": {
              color: "#35383E"
            }
          }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 1,
              mb: 2,
              px: 1,
              cursor: "pointer",
              "&:hover": {
                "& .user-name": {
                  color: "#01CCFF"
                }
              }
            }}
          >
            <img alt="nav-icon" src={UserIcon} />
            <Box>
              <Typography
                className="user-name"
                sx={{
                  color: "#ffffff",
                  fontSize: "13px",
                  fontWeight: 500,
                  lineHeight: "1.2",
                  transition: "color 0.2s ease-in-out"
                }}
              >
                {`${userData?.user_info?.first_name || ""} ${
                  userData?.user_info?.last_name || ""
                }`.trim()}
              </Typography>
            </Box>
          </Box>
        </Tooltip>

        {/* Logout Button */}
        <Button
          onClick={() => handleLogout(instance)}
          variant="outlined"
          fullWidth
          startIcon={<LogoutOutlined sx={{ fontSize: 16 }} />}
          sx={{
            borderRadius: "8px",
            fontWeight: 500,
            fontSize: "12px",
            padding: "6px 12px",
            borderColor: "#35383E",
            color: "#7E8799",
            textTransform: "none",
            backgroundColor: "transparent",
            "&:hover": {
              backgroundColor: "rgba(1, 204, 255, 0.1)",
              borderColor: "#01CCFF",
              color: "#01CCFF"
            }
          }}
        >
          Logout
        </Button>
      </Box>
    </Box>
  );

  return (
    <Box
      component="nav"
      sx={{
        width: { sm: "240px" },
        flexShrink: { sm: 0 }
      }}
    >
      {/* Mobile drawer */}
      <Drawer
        variant="temporary"
        open={mobileOpen}
        onClose={onMobileClose}
        ModalProps={{
          keepMounted: true
        }}
        sx={{
          display: { xs: "block", sm: "none" },
          "& .MuiDrawer-paper": {
            boxSizing: "border-box",
            width: 240,
            backgroundColor: "#131313",
            overflow: "hidden"
          }
        }}
      >
        {drawerContent}
      </Drawer>

      {/* Desktop drawer */}
      <Drawer
        variant="permanent"
        sx={{
          display: { xs: "none", sm: "block" },
          "& .MuiDrawer-paper": {
            boxSizing: "border-box",
            width: 240,
            backgroundColor: "#131313",
            overflow: "hidden"
          }
        }}
        open
      >
        {drawerContent}
      </Drawer>
    </Box>
  );
};

Sidebar.propTypes = {
  mobileOpen: PropTypes.bool,
  onMobileClose: PropTypes.func
};

export { Sidebar };
